import { useStore } from 'hooks/useStore';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { authServices } from 'services/authServices';
import { provisonalForecastScreenServices } from 'services/fdp/provisionalForecastServices';

const NavbarLogic = () => {
  const {
    NavbarStore: { isNavigationRestricted },
  } = useStore();
  const navigate = useNavigate();
  const handleNavigateToHomeScreen = () => {
    if (isNavigationRestricted) {
      if (window.confirm('Are you sure want to navigate??')) {
        navigate('/');
      }
    } else {
      navigate('/');
    }
  };
  const {
    UserStore: {
      isLoginLoading,
      toggleLoginLoading,
      isAuthenticated,
      handleLogout,
      userMetadata,
      isUserInfoLoading,
    },
  } = useStore();
  const [bulkTmsModalVisibility, setBulkTmsModalVisiblity] = useState(false);
  const [isProvisonalExportForecastButtonLoading, setIsProvisonalExportForecastButtonLoading] =
    useState(false);
  const [selectedUserAction, setSelectedUserAction] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Initialize theme from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme-preference');

    // Always default to light mode, regardless of system theme
    const initialTheme = savedTheme || 'light';
    const isDark = initialTheme === 'dark';

    setIsDarkMode(isDark);
    document.documentElement.setAttribute('data-theme', initialTheme);
  }, []);
  const login = async () => {
    try {
      toggleLoginLoading();
      const res = await authServices.initiateLogin();
      window.location.href = res.loginRedirectUrl;
    } catch {
      console.log('Error occured while logging in');
    } finally {
      toggleLoginLoading();
    }
    // await oktaAuth.signInWithRedirect();
  };
  const logout = async () => {
    handleLogout();
    navigate('/');
  };

  // Create dropdown options
  const dropdownOptions = [
    {
      label: 'User Profile',
      value: 'userInfo',
      type: 'userInfo',
      userName: userMetadata?.userInfo.name,
      userEmail: userMetadata?.userInfo.email,
    },
    {
      label: 'Theme Toggle',
      value: 'themeToggle',
      type: 'themeToggle',
    },
    {
      label: 'Logout',
      value: 'logout',
      type: 'logout',
    },
  ];

  const handleDropdownChange = (e: any) => {
    if (e.value?.value === 'logout') {
      logout();
    }
    // For theme toggle, we don't want to close dropdown immediately
    if (e.value?.value !== 'themeToggle') {
      // Reset selection to keep dropdown closed after action
      setSelectedUserAction(null);
    }
  };

  const handleThemeToggle = (checked: boolean) => {
    setIsDarkMode(checked);

    // Apply theme to DOM
    const theme = checked ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', theme);

    // Store theme preference in localStorage
    localStorage.setItem('theme-preference', theme);

    console.log('Theme changed to:', theme);
  };

  const isBulkUploadButtonVisible = () => {
    if (window.location.pathname.toLocaleLowerCase().includes('active_drug_strategy')) {
      return true;
    }
    return false;
  };

  const isProvisionalExportForecastButtonVisible = () => {
    if (window.location.pathname.toLocaleLowerCase().includes('provisonal_forecast')) {
      return true;
    }
    return false;
  };

  const isBulkEditButtonVisibleForMsSalesPlan = () => {
    if (
      window.location.pathname.toLocaleLowerCase().includes('fdp/target_market') &&
      !window.location.pathname.toLocaleLowerCase().includes('bulk')
    ) {
      return true;
    }
    return false;
  };

  const handleClickBulkEditButtonForMSSalesPlan = () => {
    navigate('/fdp/target_market/bulk_edit/msplan');
  };

  const toggleBulkTmsModalVisibility = () => {
    console.log(bulkTmsModalVisibility);
    setBulkTmsModalVisiblity(!bulkTmsModalVisibility);
  };

  const handleProvisonalForecastDownloadExcelFile = async () => {
    try {
      setIsProvisonalExportForecastButtonLoading(true);
      await provisonalForecastScreenServices.downloadAllProvisionalForecastExcelFile();
      toast.success('Provisional forecast exported successfully.');
    } catch (err) {
      console.log({ err });
      toast.error('Failed to export provisional forecast. Please try again.');
    } finally {
      setIsProvisonalExportForecastButtonLoading(false);
    }
  };

  return {
    handleNavigateToHomeScreen,
    userMetadata,
    isLoginLoading,
    handleLogout,
    isAuthenticated,
    login,
    logout,
    isUserInfoLoading,
    bulkTmsModalVisibility,
    toggleBulkTmsModalVisibility,
    isBulkUploadButtonVisible,
    isBulkEditButtonVisibleForMsSalesPlan,
    handleClickBulkEditButtonForMSSalesPlan,
    isProvisionalExportForecastButtonVisible,
    handleProvisonalForecastDownloadExcelFile,
    isProvisonalExportForecastButtonLoading,
    dropdownOptions,
    handleDropdownChange,
    selectedUserAction,
    isDarkMode,
    handleThemeToggle,
  };
};

export default NavbarLogic;
